import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ConversationListPanel from '../components/ConversationListPanel';

const ConversationsWrapper = () => {
  const { sessionId } = useParams();

  return (
    <Box sx={{ 
      display: 'flex', 
      flexGrow: 1,
      height: '100vh', 
      overflow: 'hidden',
      bgcolor: '#f5f5f5',
    }}>
      {/* Conversation list panel always visible */}
      <ConversationListPanel />
      
      {/* Content area - shows detail or selection message */}
      {sessionId ? (
        <Outlet />
      ) : (
        <Box 
          sx={{ 
            flexGrow: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            bgcolor: '#f0f2f5',
          }}
        >
          <Typography variant="h6" color="text.secondary">
            Select a conversation to start
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ConversationsWrapper;
